import { createSelector } from '@reduxjs/toolkit';

import { name } from './slice';
import type { TestimonialsStateType } from './types';

const getTestimonialsState = (state): TestimonialsStateType => state[name];

export const getTestimonials = createSelector(
  getTestimonialsState,
  (testimonials) => testimonials.data || null,
);

export const getTestimonialsFetching = createSelector(
  getTestimonialsState,
  (testimonials) => testimonials.fetching,
);

export const getTestimonialIds = createSelector(
  getTestimonials,
  (testimonials) =>
    testimonials ? testimonials.map((item) => item.id).join(',') : undefined,
);
